import { service } from '@ember/service';
import Component from '@glimmer/component';

import move from 'ember-animated/motions/move';
import { eq } from 'ember-truth-helpers';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import Item from './item';
import styles from './styles.module.css';

const bem = getBem(styles);

export default class ApplicationBreadcrumbComponent extends Component {
  // Services
  @service breadcrumb;

  // Transitions
  // eslint-disable-next-line require-yield
  *breadcrumbTransitiom({ removedSprites, insertedSprites }) {
    for (let sprite of removedSprites) {
      sprite.endAtPixel({ x: window.innerWidth + sprite.initialBounds.left });
      sprite.applyStyles({ 'z-index': '1' });

      move(sprite);
    }

    for (let sprite of insertedSprites) {
      sprite.startAtPixel({ x: window.innerWidth });
      sprite.applyStyles({ 'z-index': '1' });

      move(sprite);
    }
  }

  // Template
  <template>
    {{#if this.breadcrumb.isBreadcrumbVisible}}
      <ol class={{(bem)}} ...attributes>
        {{#each this.breadcrumb.routes as |route index|}}
          <Item @route={{route}} @isFirst={{eq index 0}} />
        {{/each}}
      </ol>
    {{/if}}
  </template>
}
